export enum INPUT_TYPES {
	SHORT_TEXT   = 'TEXTSINGLELINE',
	LONG_TEXT    = 'TEXTMULTILINE',
	CHECKBOX     = 'BOOLEAN',
	SELECT       = 'CHOICESINGLE',
	SELECT_MULTI = 'CHOICEMULTIPLE',
	DATE         = 'DATE',
	DATE_RANGE   = 'DATERANGE',
};

export enum INPUT_TYPE_LABELS {
	SHORT_TEXT   = 'Short Text',
	LONG_TEXT    = 'Long Summary',
	CHECKBOX     = 'Yes / No',
	SELECT       = 'Choice',
	SELECT_MULTI = 'Multiple Choices',
	DATE         = 'Date',
	DATE_RANGE   = 'Date Range',
};

export const SELECTFIELD_EMPTY_VALUE: null = null;
export const SELECTFIELD_NONE_VALUE: string = 'NONE';

export enum TOGGLE_SELECTION_STATES {
	UNPINNED = 'UNPINNED',
	ON       = 'ON',
	OFF      = 'OFF',
}
